export function getCheatFromSelectedMode(): any{
    const mode = (window as any).UIBridge?.getSelectedMode?.();
    console.log("Modalità Cheat selezionata (Modalità):", (window as any).UIBridge?.getSelectedMode?.());
    if(mode.extraActive){
        switch (mode.selectedCheatMode) {
            case 1:
            return { c: { e: 1, t: 3 } };
            case 2:
            return {c: {t: 3, e: {m: 2, d: String(mode.extraNumber)}}}
            case 3:
            return { c: { e: 2, t: 3 } }; 
        }
    } else {
        switch (mode.selectedCheatMode) {
            case 1:
            return { c: { e: 1, t: 3 } };
            case 2:
            return {c: {t: 3, e: {m: 2, d: "1"}}}
            case 3:
            return { c: { e: 2, t: 0 } }; 
        }
    }

    const symbol = (window as any).UIBridge?.getSelectionCheatSymbol?.();
    const num = Number((window as any).UIBridge?.getSelectionNumberSymbol?.());
    console.log("Modalità Cheat selezionata (Simboli):", (window as any).UIBridge?.getSelectionCheatSymbol?.());
    if(symbol !== "") {
        return { c: { t: 2, e: 1, p: {s: Number(symbol), r: num} } };
    }

    const cheatType1 = (window as any).UIBridge?.getSelectionCheatType1?.();
    console.log("Modalità Cheat selezionata (Type1):", cheatType1);
    if(Array.isArray(cheatType1) && cheatType1.length>0) {
        return { c: { t: 1, e: 1, s: cheatType1 } };
    }

    return undefined
}